<template>
    <div class="vx-card p-4">
        <div class="vx-row mt-4">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false" name="branch"
                    v-validate="'required'">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <!-- <div class="vx-col md:w-1/4 w-full">
                <label class="vs-input--label">Tìm kiếm</label>
                <vs-input class="sm:w-auto mb-2 sm:order-normal order-3 sm:mt-0 " v-model="searchQuery"
                    @input="updateSearchQuery" :placeholder="$t('button.search')" />
            </div> -->
            <div class="vx-col lg:w-2/3 md:w-1/2 w-full">
                <div class="mt-4 flex flex-wrap md:float-right">
                    <vs-button class="mr-2 mt-2" @click="$router.push('/user/assign-services-branch')" color="primary" iconPack="feather"
                        icon="icon-package" v-if="isPermissionAddService">Thêm dịch vụ cho phòng ban</vs-button>
                    <vs-button class="mt-2" @click="addDepartment" color="primary" icon-pack="feather"
                        icon="icon-plus" v-if="isPermissionAll">Thêm phòng ban</vs-button>
                </div>
            </div>
        </div>

        <div class="vs-row mt-4">
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
                :rowData="departmentData" :animateRows="true" :pagination="true"
                :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                :paginationPageSize="paginationPageSize" :onGridReady="onGridReady" :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" @change="loadPage" />
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererActions
    },

    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: 'Tên phòng ban',
                    field: 'departmentName',
                    width: 200
                },
                {
                    headerName: 'Chi nhánh',
                    field: 'organizationBranchName',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            branchOptions: [],
            selectedBranchValue: null,
            departmentData: null,
        }
    },

    created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });

        this.branchOptions.unshift({ value: null, label: 'Tất cả' })
        this.getAllDepartment();
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getAllDepartment()
            }
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteDepartment'(val) {
            if (val) {
                this.getAllDepartment();
                this.$store.commit('DELETE_DEPARTMENT', false);
            }
        },
    },

    methods: {
        isPermissionAll() {
            return isAPI(this, constAPI.department_all)
        },
        isPermissionAddService() {
            return isAPI(this, constAPI.department_add_service)
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },

        getAllDepartment() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                organizationBranchId: this.selectedBranchValue ? this.selectedBranchValue : userInfo.organizationBranchId,
            }

            this.$vs.loading();
            this.$crm.post('/department/find-by-condition', payload).then(res => {
                this.departmentData = res.data.map(el => {
                    el.stt = res.data.indexOf(el) + 1;
                    let result = this.branchOptions.find(x => x.value == el.organizationBranchId)
                    if (result) {
                        el.organizationBranchName = result.label
                    }
                    return el;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        addDepartment() {
            this.$router.push('/user/department-info')
        },

        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            let pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
            this.pageNumber = pageNumber;
        },

        isPermissionCreateDepartment() {
            return isAPI(this, constAPI.depa);
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>
